import React from "react";
import "./reportPreview.css";

import {
  ChevronLeft,
  FileText,
  Calendar,
  Users,
  MessageSquare,
  BookOpen,
  CheckCircle,
  AlertCircle,
} from "lucide-react";

const WeeklyReportPreview = ({ report, onClose, onSubmit, isSubmitting }) => {
  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="preview-title">
      <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="preview-header">
          <FileText className="preview-icon" aria-hidden />
          <h1 id="preview-title" className="preview-title">Weekly Report Preview</h1>
        </div>

        <div className="preview-body">
          <div className="preview-section">
            <h2>
              <BookOpen size={20} aria-hidden /> Module
            </h2>
            <p>{report.moduleCode || "—"}</p>
          </div>

          <div className="preview-section">
            <h2>
              <Calendar size={20} aria-hidden /> Dates
            </h2>
            <p>
              From: {report.startDate || "—"} — To: {report.endDate || "—"}
            </p>
          </div>

          <div className="preview-section">
            <h2>
              <CheckCircle size={20} aria-hidden /> Summary of the Week
            </h2>
            <p>{report.weeklyActivity || "—"}</p>
          </div>

          <div className="preview-section">
            <h2>
              <AlertCircle size={20} aria-hidden /> Challenges
            </h2>
            <p>{report.challenges || "—"}</p>
          </div>

          <div className="preview-section">
            <h2>
              <MessageSquare size={20} aria-hidden /> Suggestions
            </h2>
            <p>{report.suggestions || "—"}</p>
          </div>

          <div className="preview-section">
            <h2>
              <MessageSquare size={20} aria-hidden /> Communication Channels
            </h2>
            <ul>
              {report.channelActivities && Object.keys(report.channelActivities).length > 0
                ? Object.entries(report.channelActivities).map(([channelName, activity], index) => (
                    <li key={index}>
                      <strong>{channelName}:</strong>{" "}
                      <span className="preview-section-text">{activity}</span>
                    </li>
                  ))
                : <li>None</li>}
            </ul>
          </div>

          <div className="preview-section">
            <h2>
              <Users size={20} aria-hidden /> Session Details
            </h2>
            <ul>
              {report.sessions && report.sessions.length > 0
                ? report.sessions.map((s, i) => (
                    <li key={i}>
                      Session {s.sessionNumber} | {s.moduleCode || ""}: Group — {s.groupName || "—"} | Students: {s.numberOfStudents ?? "—"} | Date: {s.sessionDate || "—"}
                    </li>
                  ))
                : <li>No sessions</li>}
            </ul>
          </div>
        </div>

        <div className="modal-buttons">
          <button type="button" onClick={onClose} className="btn-secondary">
            <ChevronLeft size={16} aria-hidden /> Back
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled={isSubmitting}
            onClick={() => {
              if (isSubmitting) return;
              onClose();
              setTimeout(() => onSubmit({ preventDefault: () => {} }), 0);
            }}
          >
            <CheckCircle size={16} aria-hidden />
            {isSubmitting ? "Submitting..." : "Submit Report"}
          </button>
        </div>
      </div>
    </div>
  );
};
export default WeeklyReportPreview;
